import { FieldValidator } from '@ov-suite/helpers-angular';
import { User } from '@ov-suite/models-idm';
import { OvAutoService } from '@ov-suite/services';
import gql from 'graphql-tag';
import { Injectable } from '@angular/core';

@Injectable()
export class PinValidator implements FieldValidator<User> {
  errorMessage = 'Pin Address already In Use';

  constructor(private readonly ovAutoService: OvAutoService) {}

  async validate(user: User): Promise<boolean> {
    return this.ovAutoService.apollo
      .use('adminlink')
      .query<boolean>({
        query: gql(`query checkPinInUse($pin: String!, $email: String!) {
          checkPinInUse(pin: $pin, email: $email)
        }`),
        variables: {
          pin: user.userPin,
          email: user.email,
        },
      })
      .toPromise()
      .then(res => !res.data['checkPinInUse']);
  }

  async required(user: User): Promise<boolean> {
    return user.cognitoUser;
  }
}
